import React from "react";

import { Link } from "react-router-dom";

export default function HeadBefore() {
  return (
    <div className=" header-menu-wrapper">
      <div className="header">
        <div className="d-flex w-100 h-25 ps-5 pe-5 me-5">
          <div className="pe-5 text-white">
            <Link className="" to={"/"}>
              صفحه اصلی
            </Link>
          </div>
          <div className="pe-5 text-white">
            <Link className="" to={"/about"}>
              درباره ما
            </Link>
          </div>

          <div className="pe-5 text-white">
            <Link className="" to={"/help"}>
              راهنمای استفاده
            </Link>
          </div>
          <div className="pe-5 "></div>
        </div>
      </div>
    </div>
  );
}
